<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="장소별 라인 목록"
          :columns="grid.columns"
          :data="lines"
          :usePaging="false"
          selection="multiple"
          rowKey="lineId"
          :editable="editable"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn 
                v-if="editable && pick.placeId" 
                label="삭제" 
                icon="remove" 
                @btnClicked="deleteLine" />
              <c-btn 
                v-if="editable && pick.placeId" 
                label="추가" 
                :showLoading="false" 
                icon="add" 
                @btnClicked="addLine" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'patrol-place-item-result',
  props: {
    lines: {
      type: Array,
      default: () => []
    },
    pick: {
      type: Object,
      default: () => ({
        plantCd: '',
        placeId: '',
      }) 
    },
  },
  data() {
    return {
      editable: true,
      popupOptions: {
        isFull: false,
        width: '50%',
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
      grid: {
        columns: [
          {
            name: 'lineCd',
            field: 'lineCd',
            label: '라인명',
            align: 'center',
            sortable: false,
          },
          // {
          //   name: 'sortOrder',
          //   field: 'sortOrder',
          //   label: '순번',
          //   align: 'center',
          //   style: 'width:100px',
          //   type: 'number',
          //   sortable: false,
          // },
        ],
        data: [],
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  watch: {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.insertUrl = transactionConfig.sai.patrol.linePlace.insert.url;
      this.deleteUrl = transactionConfig.sai.patrol.linePlace.delete.url;
    },
    
    addLine() {
      if (!this.pick.placeId) return;
      this.popupOptions.title = '순회점검항목';
      this.popupOptions.param = {
        type: 'multiple',
        plantCd: this.pick.plantCd
      };
      this.popupOptions.target = () => import(`${'@/pages/common/process/linePop.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.width = '40%';
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let insertData = [];
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.lines, { lineId: item.lineId }) === -1) {
            // let idx = this.$_.findIndex(this.lines, { saiEquipClassName: item.saiEquipClassName, saiItemClassName: item.saiItemClassName })
            // idx = idx === -1 ? this.$_.findIndex(this.lines, { saiEquipClassName: item.saiEquipClassName }) : 0
            // idx = idx === -1 ? 0 : idx;
            insertData.push({
              placeId: this.pick.placeId,
              lineCd: item.lineCd,
              lineId: item.lineId,
            })
          }
        })
        
        this.$http.url = this.insertUrl;
        this.$http.type = 'POST';
        this.$http.param = insertData
        this.$http.request(() => {
          window.getApp.$emit('APP_REQUEST_SUCCESS');
          this.$emit('getList');
          this.$emit('rowClick', this.$_.cloneDeep(this.pick));
        },);
      }
    },
    deleteLine() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.deleteUrl;
          this.$http.type = 'DELETE';
          this.$http.param = {
            data: Object.values(selectData)
          }
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            
            // this.$_.forEach(selectData, item => {
            //   this.lines = this.$_.reject(this.lines, item);
            // })
            this.$refs['table'].$refs['compo-table'].clearSelection();
            this.$emit('getList');
            /**
             * 입력하는 항목이 없음으로 삭제 처리 후에 조회처리
             */
            this.$emit('rowClick', this.$_.cloneDeep(this.pick));
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
      }
    },
  }
};
</script>
